import PropTypes from 'prop-types'
import React from 'react'
import Tooltip from "@mui/material/Tooltip";

/**
 * Component for an individual track (ie timeline segment/interval) to be
 * displayed on a timeline.
 *
 * @param error            An object containing any current errors, or null
 * @param {number} sourceOffset   Number between 0 and 1 defining distance along the timeline for start of track
 * @param {number} targetOffset   Number between 0 and 1 defining distance along the timeline for end of track
 * @param {func} getTrackProps    Function to get props for this track passed in from the React-Compound-Slider Tracks component
 * @param {bool} disabled         If true, will adjust how track is displayed
 * @param {string} className      Extra css classes to be added to track
 * @param {string} tooltip        If not null, will display a tooltip when user hovers over track
 * @returns {JSX.Element}
 * @constructor
 */
const Track = ({
    error,
    sourceOffset,
    targetOffset,
    getTrackProps,
    disabled,
    className,
    tooltip
}) => {

    const trackDiv = <div
        className={`react_time_range__track${disabled ? '__disabled' : ''} ${className} ${error ? 'error' : ''}`}
        style={{
            left: `${sourceOffset}%`,
            width: `calc(${targetOffset - sourceOffset}% + 1px)`,
        }}
        {...getTrackProps()}
    />;

    return (tooltip)
        ? <Tooltip title={tooltip}>{trackDiv}</Tooltip>
        : trackDiv
    ;
}

Track.propTypes = {
    sourceOffset: PropTypes.number.isRequired,
    targetOffset: PropTypes.number.isRequired,
    getTrackProps: PropTypes.func.isRequired,
    disabled: PropTypes.bool
}

Track.defaultProps = {
    disabled: false,
    className: '',
}

export default Track
